// src/services/ConfigService.js
import { apiClient } from "./ApiClient";

export const ConfigService = {
  // Company Data
  getCompanyConfig: async (token) => {
    const response = await apiClient.get("/config/company", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  updateCompanyConfig: async (data, token) => {
    const response = await apiClient.post("/config/company", data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Service Config
  getServiceConfig: async (token) => {
    const response = await apiClient.get("/config/service", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  updateServiceConfig: async (data, token) => {
    const response = await apiClient.post("/config/service", data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Secret Data
  getSecretConfig: async (token) => {
    const response = await apiClient.get("/config/secret", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  updateSecretConfig: async (data, token) => {
    const response = await apiClient.patch("/config/secret", data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Batch load all configs (użyj w useEffect)
  loadAllConfigs: async (token) => {
    const [company, service, secret] = await Promise.all([
      ConfigService.getCompanyConfig(token),
      ConfigService.getServiceConfig(token),
      ConfigService.getSecretConfig(token),
    ]);
    return { company, service, secret };
  },
};
